import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { supabase } from './services';

// Handle Supabase auth callback (email confirmation)
// This runs before React mounts to catch the auth tokens in URL
const handleAuthCallback = async () => {
  // Check if URL has auth tokens (from email confirmation)
  const hashParams = new URLSearchParams(window.location.hash.substring(1));
  const queryParams = new URLSearchParams(window.location.search);
  
  // Supabase puts tokens in hash fragment or query params
  const accessToken = hashParams.get('access_token') || queryParams.get('access_token');
  const refreshToken = hashParams.get('refresh_token') || queryParams.get('refresh_token');
  const type = hashParams.get('type') || queryParams.get('type');
  
  if (accessToken && refreshToken) {
    try {
      // Set the session from the tokens
      const { data, error } = await supabase.auth.setSession({
        access_token: accessToken,
        refresh_token: refreshToken,
      });
      
      if (error) {
        console.error('Auth callback error:', error);
        window.location.href = '/#/login';
        return;
      }
      
      if (data.session?.user) {
        // Check if user is invited (needs to set password)
        const isInvited = data.session.user.user_metadata?.is_invited;
        
        // Clear the URL tokens and redirect appropriately
        if (isInvited) {
          window.location.href = '/#/set-password';
        } else {
          window.location.href = '/#/';
        }
        return;
      }
    } catch (err) {
      console.error('Auth callback processing error:', err);
      window.location.href = '/#/login';
      return;
    }
  }
};

// Run auth callback handler first
handleAuthCallback().then(() => {
  // Only render if we haven't redirected
  if (!window.location.hash.includes('access_token')) {
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }
});
